import { styled } from '@linaria/react';
import { useSpring } from 'react-spring';

import useSequence from './use-sequence.hook';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  ChildElement,
  SPRING_CONFIGS,
} from './bits';

function MarginCollapseOpposing() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `
      translateX(${stepIndex === 0 ? 0 : -25}%)
    `,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 25}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 3, ...firstSpring }}>
        <Skew>
          <ChildElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {'<p>'}
            </TextWrapper>
          </ChildElement>
          <TopMargin />
        </Skew>
      </Layer>
      <Layer style={{ zIndex: 2 }}>
        <Skew>
          <BaseElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {'<div>'}
            </TextWrapper>
          </BaseElement>
        </Skew>
      </Layer>

      <Layer style={{ top: 125 + 48 + 2, ...secondSpring }}>
        <Skew>
          <BottomMargin />
          <BaseElement>
            <TextWrapper style={{ opacity: stepIndex === 2 ? 1 : 0 }}>
              {'<p>'}
            </TextWrapper>
          </BaseElement>
        </Skew>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 460px;
`;

const TextWrapper = styled.span`
  transition: opacity 500ms;
  display: inline-block;
  padding: 16px;
  background: var(--color-background);
`;

const TopMargin = styled(BaseMargin)`
  height: 48px;
`;
const BottomMargin = styled(BaseMargin)`
  height: 48px;
`;

export default MarginCollapseOpposing;
